module.exports = __webpack_public_path__ + "static/media/visa.9d1f63cf.svg";